import { Row, Col, Accordion } from "react-bootstrap"
import * as S from "./styled"
import { item as text } from "../../../../i18n/pt.json"
import { Modal } from "../../../Modal"
import Link from "../../../Base/link"
import { mountRedirect } from "../../../../utils/redirect.service"

const Collapse = ({ details, enable }) => (
  <Accordion.Collapse style={{ transition: "all 500ms" }} in={enable} eventKey="0">
    <>
      {details.map((detail) => (
        <div>
          <Row>
            <S.ServiceHeader xs={2} lg={2}>
              {text.service}
            </S.ServiceHeader>
            <S.ServiceHeader xs={2} lg={2}>
              {text.dnp}
            </S.ServiceHeader>
            <S.ServiceHeader xs={2} lg={2}>
              {text.height}
            </S.ServiceHeader>
            <S.ServiceHeader xs={2} lg={2}>
              {text.service}
            </S.ServiceHeader>
            <S.ServiceHeader xs={2} lg={2}>
              {text.dnp}
            </S.ServiceHeader>
            <S.ServiceHeader xs={2} lg={2}>
              {text.height}
            </S.ServiceHeader>

            <Col xs={2} lg={2}>
              <i>{text.rightEye}</i>
            </Col>
            <Col xs={2} lg={2}>
              {detail.RDNP}
            </Col>
            <Col xs={2} lg={2}>
              {detail.RALTURA}
            </Col>
            <Col xs={2} lg={2}>
              <i>{text.leftEye}</i>
            </Col>
            <Col xs={2} lg={2}>
              {detail.LDNP}
            </Col>
            <Col xs={2} lg={2}>
              {detail.LALTURA}
            </Col>
          </Row>

          <S.Frame>
            <Col xs={2} lg={4} className="col-lg mt-3">
              {text.brand}
              <br />
              {detail.MARCA}
            </Col>
            <Col xs={2} lg={4} className="col-lg mt-3">
              {text.model}
              <br />
              {detail.MODELO}
            </Col>
            <Col xs={2} lg={4} className="col-lg mt-3">
              {text.color}
              <br />
              {detail.COR}
            </Col>
            <Col xs={2} lg={4} className="col-lg mt-3">
              {text.rim}
              <br />
              {detail.Aro}
            </Col>
            <Col xs={2} lg={4} className="col-lg mt-3">
              {text.bridge}
              <br />
              {detail.PONTE}
            </Col>
            <Col xs={2} lg={4} className="col-lg mt-3">
              {text.rimType}
              <br />
              {detail.TIPOARO}
            </Col>
            <Col xs={2} lg={4} className="col-lg mt-3">
              {text.material}
              <br />
              {detail.MATERIAL}
            </Col>
          </S.Frame>
        </div>
      ))}
    </>
  </Accordion.Collapse>
)

export const Header = () => {
  const { header } = text

  return (
    <S.Header className="d-flex w-100">
      <Col xs={2} className="d-lg-block">
        <S.TextHeader>{header.product}</S.TextHeader>
      </Col>
      <Col xs={2} lg={1}>
        <S.TextHeader>{text.item}</S.TextHeader>
      </Col>
      <Col xs={2} lg={2} className="d-xs-block d-sm-none">
        <S.TextHeader>{header.esf}</S.TextHeader>
      </Col>
      <Col xs={2} lg={2} className="d-none d-sm-block">
        <S.TextHeader>{header.spherical}</S.TextHeader>
      </Col>
      <Col xs={1} lg={2} className="d-xs-block d-sm-none">
        <S.TextHeader>{header.cil}</S.TextHeader>
      </Col>
      <Col xs={1} lg={2} className="d-none d-sm-block">
        <S.TextHeader>{header.cylindrical}</S.TextHeader>
      </Col>
      <Col xs={1} lg={2}>
        <S.TextHeader>{header.axle}</S.TextHeader>
      </Col>
      <Col xs={2} lg={1} className="d-none d-lg-block pr-0">
        <S.TextHeader>{header.edition}</S.TextHeader>
      </Col>
      <Col xs={2} lg={1} className="d-sm-none d-xs-block pr-0">
        <S.TextHeader>{header.edit}</S.TextHeader>
      </Col>
      <Col xs={1} lg={2} className="d-none d-lg-block">
        <S.TextHeader>{header.delete}</S.TextHeader>
      </Col>
      <Col xs={1} lg={1} className="d-sm-none d-xs-block">
        <S.TextHeader>{header.del}</S.TextHeader>
      </Col>
    </S.Header>
  )
}

export const Layout = ({ item, editRoute, details, handleDelete, collapse, toggleCollapse }) => (
  <>
    <Header />
    <Accordion defaultActiveKey={item.single ? "0" : ""}>
      <S.Description>
        <Row noGutters style={{ lineHeight: "2.5rem" }}>
          <Col xs={2} lg={2}>
            <Link action={editRoute}>
              <S.Lente url={item.lente} />
            </Link>
          </Col>
          <Col xs={1} lg={1}>
            <i>{text.rightEye}</i>
            <br />
            <i>{text.leftEye}</i>
          </Col>
          <Col xs={2} lg={2}>
            <S.Text>{item.DIR_ESFER}</S.Text>
            <br />
            <S.Text>{item.ESQ_ESFER}</S.Text>
          </Col>
          <Col xs={2} lg={2}>
            <S.Text>{item.DIR_CIL}</S.Text>
            <br />
            <S.Text>{item.ESQ_CIL}</S.Text>
          </Col>
          <Col xs={2} lg={2}>
            <S.Text>{item.DIR_EIXO}</S.Text>
            <br />
            <S.Text>{item.ESQ_EIXO}</S.Text>
          </Col>
          <Col xs={1} lg={1} className="d-flex justify-content-end">
            <S.IconEdit
              data-testid="editRedirectParapar"
              item={item.itemID}
              onClick={mountRedirect(editRoute)}
            />
          </Col>
          <Col xs={2} lg={2}>
            <Modal deleteModal fn={handleDelete} />
          </Col>
        </Row>
      </S.Description>

      <S.Details>
        <Row noGutters className="mb-2 d-flex">
          <Col xs={2} lg={4}>
            <div className="d-lg-block">
              {text.osCLI}
              {item.OSCLI}
            </div>
            {text.productName}
            {item.nome}
          </Col>
          <Col xs={6} lg={4} className="text-center d-lg-block">
            {item.mounting && (
              <S.ShowDetails data-testid="openCollapseParapar" onClick={toggleCollapse}>
                {text.viewService}&nbsp;&nbsp;
                <img src="/images/montagem.png" alt="montagem" />
              </S.ShowDetails>
            )}
          </Col>
          <Col xs={4} lg={4} className="text-right">
            {text.lensValue}
            {item.price}
            <br />
            {item.mounting && (
              <>
                {text.serviceValue}
                {item.service}
              </>
            )}
          </Col>
        </Row>

        <Collapse details={details} enable={collapse} />
      </S.Details>
    </Accordion>
  </>
)
